export default function Marquee({ text = "VOLTAGE VIPERS · STRIKE FAST · ENGINEER THE FUTURE · FTC ROBOTICS · " }) {
  const repeated = Array(8).fill(text).join("");
  return (
    <div
      data-testid="marquee"
      className="overflow-hidden border-y border-voltage-blue/30 bg-voltage-bg py-6 select-none"
    >
      <div className="flex whitespace-nowrap animate-marquee will-change-transform">
        <span className="font-display font-black text-6xl md:text-8xl tracking-tighter text-transparent pr-8" style={{ WebkitTextStroke: "1px #1E3FD8" }}>
          {repeated}
        </span>
        <span className="font-display font-black text-6xl md:text-8xl tracking-tighter text-transparent pr-8" style={{ WebkitTextStroke: "1px #1E3FD8" }}>
          {repeated}
        </span>
      </div>
    </div>
  );
}
